import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the CustomizerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CustomizerProvider {

  private m_takeAwayToken: String;
  private m_takeAwayDeliveryToken: String;
  private m_selfOrderingToken: String;
  private m_readingMenuToken: String;
  private m_upperHomeImage: String;
  private m_lowerHomeImage: String;

  private m_hasTakeAway: Boolean;
  private m_hasTakeAwayDelivery: Boolean;
  private m_hasSelfOrdering: Boolean;
  private m_hasReadingMenu: Boolean;

  private m_usePrivateUserDatabase: Boolean;
  private m_apiUrl: String;
  private m_productFont: String;
  private m_logo: String;
  private m_hideDriver: Boolean;
  private m_splitHomePage: Boolean;
  private m_hotelWithTime: Boolean;
  private m_customRestaurantName: String;
  private m_webAppMode: Boolean;
  private m_text_example_search: String; 
  private m_searchButton: Boolean;
  private m_totemMode: Boolean;

  // languages
  private m_defaultLanguage: string;

  // colors
  private m_colorBtnSelfOrdering: String;
  private m_colorBtnTakeAway: String;
  private m_colorBtnReadingMenu: String;
  private m_colorNavbar: String;
  private m_colorBadgeCart: String;
  private m_colorIngredient: String;
  private m_colorVariant: String;
  private m_colorBtnAddToCart: String;
  private m_colorFooterCart: String;
  private m_colorBtnCustomerFooter: String;
  private m_colorCardCustomer: String;
  private m_colorToolbarAsporto: String;
  private m_colorNoMoreSlots: String;
  private m_colorNavPagaDopo: String;
  private m_colorNavPagaOra: String;
  private m_colorButtonQuantity: String;

  // se sposti da qui la riga qui sotto ti accadrà qualcosa di molto brutto
  private m_multi_app: Boolean = false;

  pwaView = '';

  constructor(public http: HttpClient) {
    console.log('App customization provider ready');
    this.reset();
  }

  private reset() {
    console.log('Reset config to defaults');
    // reset all values EXCEPT the m_multi_app !!
    this.m_takeAwayToken = null;
    this.m_takeAwayDeliveryToken = null;
    this.m_selfOrderingToken = null;
    this.m_readingMenuToken = null;
    this.m_upperHomeImage = 'assets/sfondo1.jpg';
    this.m_lowerHomeImage = 'assets/sfondo.jpg';
  
    this.m_hasTakeAway = true;
    this.m_hasTakeAwayDelivery = true;
    this.m_hasSelfOrdering = true;
    this.m_hasReadingMenu = true;
    this.m_totemMode = false;
  
    this.m_usePrivateUserDatabase = false;
    this.m_apiUrl = 'https://api.tapmenu.it';
    this.m_productFont = null;
    this.m_logo = 'assets/appicon.png';
    this.m_hideDriver = false;
    this.m_splitHomePage = true;
    this.m_hotelWithTime = false;
    this.m_webAppMode = false;
    this.m_customRestaurantName = null;
    this.m_text_example_search = 'Es. "Margherita"';
    this.m_searchButton = true;

    // languages
    this.m_defaultLanguage = 'en';

    // colors
    this.m_colorBtnSelfOrdering = 'primary';
    this.m_colorBtnTakeAway = 'tertiary';
    this.m_colorBtnReadingMenu = 'primary';
    this.m_colorNavbar = 'primary';
    this.m_colorBadgeCart = 'secondary';
    this.m_colorIngredient = 'ingredients';
    this.m_colorVariant = 'variants';
    this.m_colorBtnAddToCart = 'tertiary';
    this.m_colorFooterCart = 'secondary';
    this.m_colorBtnCustomerFooter = 'tertiary';
    this.m_colorCardCustomer = 'secondary';
    this.m_colorToolbarAsporto = 'secondary';
    this.m_colorNoMoreSlots = 'danger';
    this.m_colorNavPagaDopo = 'secondary';
    this.m_colorNavPagaOra = 'secondary';
    this.m_colorButtonQuantity = 'primary';

    // se resetti qui la variabile multi_app, ti accadrà qualcosa di molto brutto

  }

  //! loadCustomization loads a customizer
  public loadCustomization(name, tableToken?, bundleIdName?) : Promise<any> {
    // load defaults if needed
    if (!name)
      name = 'customization.json';
    // reset to defaults
    this.reset();
    // load from config
    console.log('Loading app customization from file ' + name);
    return new Promise((resolve, reject) => {
      this.http.request('GET', 'assets/customization/' + name, { responseType: 'json' })
        .subscribe((config: any) => {
          // arguments
          for (var property in config) {
            var localPropertyName = 'm_' + property;
            if (this.hasOwnProperty(localPropertyName)) {
              console.log('Using ' + property + ' ' + config[property]);
              this[localPropertyName] = config[property];
            } else {
              console.log('Unknown/wrong property name ' + property);
            }        
          }

          // process residual bundleIdName & tableToken
          if (bundleIdName && tableToken == '-') {
            this.m_hasReadingMenu = false;
            this.m_hasTakeAwayDelivery = false;
            this.m_hasTakeAway = false;
            this.m_hasSelfOrdering = false;
            this.pwaView = bundleIdName;
          } else if (tableToken && bundleIdName) {
            this.m_selfOrderingToken = tableToken;
            this.m_hasReadingMenu = true;
            this.m_hasTakeAwayDelivery = false;
            this.m_hasTakeAway = false;
            this.m_hasSelfOrdering = true;
            this.m_hideDriver = true;
            this.pwaView = bundleIdName;
          }  

          resolve(config);
        }, (err) => {
          console.log('Config not found, using default');
        })
    }).catch(err => {
      console.log('Avoid loading exception');
    });
  }

  //! multi_app returns if tapmenu contains several apps
  public multiApp(): Boolean {
    return this.m_multi_app;
  }

  //! takeAwayToken returns the static JWT to use with this app for selfOrdering orders
  public selfOrderingToken(): String {
    return this.m_selfOrderingToken;
  }

  //! takeAwayToken returns the static JWT to use with this app for sfogliamenu
  public readingMenuToken(): String {
    return this.m_readingMenuToken;
  }

  //! orderToken returns the static JWT to use with this app for takeaway orders
  public takeAwayToken(): String {
    return this.m_takeAwayToken;
  }

  public takeAwayDeliveryToken(): String {
    return this.m_takeAwayDeliveryToken;
  }

  //! get upper image to draw in home-page
  public getUpperHomeImage(): String {
    return this.m_upperHomeImage;
  }

  //! get lower image to draw in home-page
  public getLowerHomeImage(): String {
    return this.m_lowerHomeImage;
  }

  //! check if customer has take away
  public hasTakeAway(): Boolean {
    return this.m_hasTakeAway;
  }

  public hasTakeAwayDelivery(): Boolean {
    return this.m_hasTakeAwayDelivery;
  }

  //! check if customer has self-ordering
  public hasSelfOrdering(): Boolean {
    return this.m_hasSelfOrdering;
  }

  //! check if customer has sfogliamenu
  public hasReadingMenu(): Boolean {
    return this.m_hasReadingMenu;
  }

  //! splitHomePage if needed
  public splitHomePage(): Boolean {
    return this.m_splitHomePage;
  }

  //! isUsePrivateUserDatabase specify if app should use a private user database or global
  public isUsePrivateUserDatabase(): Boolean {
    return this.m_usePrivateUserDatabase;
  }

  //! getUserDatabaseURL returns to provider the database name to use for customers
  public getUserDatabaseURL() : String {
    return (this.m_apiUrl + (this.m_usePrivateUserDatabase ? "/private-customers" : "/customers" ));
  }

  //! getUserDatabaseURL returns to provider the database name to use for customers
  public getUserDatabaseURL2() : String {
    return (this.m_apiUrl + (this.m_usePrivateUserDatabase ? "/private-customers" : "/general-customers" ));
  }

  //! getApiURL returns the API Url 
  public getApiURL() : String {
    return this.m_apiUrl;
  }

  //! visualizzazione tasto di ricerca
  public searchButton(): Boolean {
    return this.m_searchButton;
  }

  //! getProductFont returns the font to be applied to product list
  public getProductFont() : String {
    return this.m_productFont;
  }

  //! getLogo returns the logo
  public getLogo(): String {
    return this.m_logo;
  }

  //! isDriverHidden returns if the driver should be hidden in main page
  public isDriverHidden(): Boolean {
    return this.m_hideDriver;
  }

  //! isHotelWithTime returns true if slots are needed in hotel
  public isHotelWithTime(): Boolean {
    return this.m_hotelWithTime;
  }

  //! getCustomRestaurantName returns the custom restaurant name
  public getCustomRestaurantName(): String {
    return this.m_customRestaurantName;
  }

  // testo di esempio per la barra di ricerca
  public getTextSearch(): String {
    return this.m_text_example_search;
  }

  //! get custom colors
  public getColorBtnSelfOrdering(): String {
    return this.m_colorBtnSelfOrdering;
  }
  public getColorBtnTakeAway(): String {
    return this.m_colorBtnTakeAway;
  }
  public getColorBtnReadingMenu(): String {
    return this.m_colorBtnReadingMenu;
  }
  public getColorNavbar(): String {
    return this.m_colorNavbar;
  }
  public getColorBadgeCart(): String {
    return this.m_colorBadgeCart;
  }
  public getColorIngredient(): String {
    return this.m_colorIngredient;
  }
  public getColorVariant(): String {
    return this.m_colorVariant;
  }
  public getColorBtnAddToCart(): String {
    return this.m_colorBtnAddToCart;
  }
  public getColorFooterCart(): String {
    return this.m_colorFooterCart;
  }
  public getColorBtnCustomerFooter(): String {
    return this.m_colorBtnCustomerFooter;
  }
  public getColorCardCustomer(): String {
    return this.m_colorCardCustomer;
  }
  public getColorToolbarAsporto(): String {
    return this.m_colorToolbarAsporto;
  }
  public getColorNoMoreSlots(): String {
    return this.m_colorNoMoreSlots;
  }
  public getColorNavPagaDopo(): String {
    return this.m_colorNavPagaDopo;
  }
  public getColorNavPagaOra(): String {
    return this.m_colorNavPagaOra;
  }
  public getDefaultLanguage(): string {
    return this.m_defaultLanguage;
  }
  public isWebAppMode(): Boolean {
    return this.m_webAppMode;
  }
  public getAppLink(): String {
    return 'https://q2w.it/t/<id>/app';
  }
  public getColorButtonQuantity(): String {
    return this.m_colorButtonQuantity;
  }
  public isTotemMode() : Boolean {
    return this.m_totemMode;
  }
}



// WEBPACK FOOTER //
// ./src/providers/customizer/customizer.ts